import { api } from '@/shared/api';
import { AxiosError } from 'axios';
import type { ApplicationDetail } from '../model/types';

/**
 * 申し込み詳細を取得する
 * @param applicationId - 申し込みID
 * @returns 申し込み詳細データ
 */
export const fetchApplicationDetail = async (applicationId: string): Promise<ApplicationDetail> => {
    try {
        const response = await api.get('/applications/{application_id}', {
            path: { application_id: applicationId },
        });

        return response;
    } catch (error) {
        const axiosError = error as AxiosError;

        if (axiosError.status === 404) {
            throw new Error('申し込みデータがありません。');
        }
        throw new Error('申し込み詳細の取得中にエラーが発生しました。');
    }
};
